// extracted by mini-css-extract-plugin
export default {"tooltip":"eT-z","arrow":"fT-z"};